// B1-INT - Ünite 3: Tam Mülakat Simülasyonu
// B1 seviyesinde basit İngilizce ile gerçekçi mülakat pratiği

export const B1INT_UNIT_3 = {
  'B1INT-U3-L1': {
    id: 'B1INT-U3-L1',
    title: 'Tam Mülakat: Giriş',
    type: 'simulation',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎭 Tam Mülakat Simülasyonu',
          content: 'Şimdi öğrendiğin her şeyi bir araya getiriyoruz!\n\nBu ders, gerçek bir mülakattan örnekler içeriyor. Ayşe adında bir aday, THY mülakatına giriyor. Onun cevaplarını incele ve öğren.\n\n⏱️ Gerçek mülakat: 15-30 dakika\n👥 Genellikle 1-2 mülakatçı\n📋 5-10 soru'
        },
        {
          type: 'scenario',
          title: '✈️ MÜLAKAT BAŞLIYOR: Tanışma',
          dialogues: [
            {
              speaker: 'Ortam',
              text: 'Interview room at Turkish Airlines headquarters. Ayşe enters, smiles, and walks confidently.',
              translation: 'Türk Hava Yolları genel merkezinde mülakat odası. Ayşe içeri giriyor, gülümsüyor ve kendinden emin yürüyor.'
            },
            {
              speaker: 'Mülakatçı (HR)',
              text: 'Good morning! Please come in and have a seat.',
              translation: 'Günaydın! Lütfen gelin ve oturun.'
            },
            {
              speaker: 'Aday (Ayşe)',
              text: 'Good morning! Thank you so much.',
              translation: 'Günaydın! Çok teşekkür ederim.'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Kısa ve kibar. Gülümsemeyi unutma!',
              translation: ''
            },
            {
              speaker: 'Mülakatçı',
              text: 'How was your journey here today?',
              translation: 'Bugün buraya gelişiniz nasıldı?'
            },
            {
              speaker: 'Aday (Ayşe)',
              text: 'It was very smooth, thank you for asking. I took the metro, and it was easy to find.',
              translation: 'Çok sorunsuzdu, sorduğunuz için teşekkürler. Metroyla geldim ve bulmak kolaydı.'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ "Small talk" soruları ciddiye al. Pozitif cevap ver.',
              translation: ''
            }
          ]
        },
        {
          type: 'scenario',
          title: '📋 İlk Soru: Tell me about yourself',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'So, let\'s begin. Tell me about yourself.',
              translation: 'Peki, başlayalım. Bize kendinizden bahsedin.'
            },
            {
              speaker: 'Aday (Ayşe)',
              text: 'Of course! My name is Ayşe Yılmaz, and I\'m 25 years old. I\'m from İzmir.',
              translation: 'Tabii! Benim adım Ayşe Yılmaz, 25 yaşındayım. İzmir\'liyim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I studied Tourism and Hotel Management at Ege University. After graduation, I worked at a 5-star hotel in Çeşme for two years.',
              translation: 'Ege Üniversitesi\'nde Turizm ve Otel İşletmeciliği okudum. Mezuniyetten sonra Çeşme\'de 5 yıldızlı bir otelde iki yıl çalıştım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I was a guest relations officer. I loved helping international guests and making their holidays special.',
              translation: 'Misafir ilişkileri görevlisiydim. Uluslararası misafirlere yardım etmeyi ve tatillerini özel kılmayı sevdim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Now I want to bring this experience to the sky! That\'s why I\'m applying for cabin crew at Turkish Airlines.',
              translation: 'Şimdi bu deneyimi gökyüzüne taşımak istiyorum! Bu yüzden Türk Hava Yolları\'nda kabin memurluğuna başvuruyorum.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Cevap Analizi',
          content: '✅ **Ayşe\'nin cevabı neden iyi:**\n• Basit ve net cümleler kullandı\n• Geçmiş → Şimdi → Gelecek yapısını izledi\n• İşle alakalı deneyim (otel, misafir hizmetleri)\n• "Bring this experience to the sky" - güzel bir bağlantı\n• 30-45 saniye - ideal uzunluk'
        },
        {
          type: 'tip',
          content: '💡 "Tell me about yourself" cevabı 1 dakikayı geçmemeli. Sadece profesyonel bilgiler ver!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Ayşe cevabında hangi yapıyı kullandı?',
          options: [
            'Sadece eğitim bilgisi',
            'Geçmiş → Şimdi → Gelecek',
            'Sadece neden bu işi istediği',
            'Ailesini ve hobilerini anlattı'
          ],
          correctIndex: 1,
          explanation: 'Geçmiş (eğitim, otel işi) → Şimdi (deneyim) → Gelecek (kabin memurluğu hedefi)'
        }
      ]
    }
  },

  'B1INT-U3-L2': {
    id: 'B1INT-U3-L2',
    title: 'Tam Mülakat: Motivasyon',
    type: 'simulation',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎭 Mülakat Devam Ediyor',
          content: 'Ayşe tanışma sorularını iyi cevapladı. Şimdi mülakatçı motivasyonunu test edecek.\n\n📌 Bu bölümde öğreneceksin:\n• "Why cabin crew?" sorusuna nasıl cevap verilir\n• "Why Turkish Airlines?" sorusuna nasıl cevap verilir'
        },
        {
          type: 'scenario',
          title: '✈️ Soru 2: Why do you want to be cabin crew?',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Why do you want to become a cabin crew member?',
              translation: 'Neden kabin memuru olmak istiyorsunuz?'
            },
            {
              speaker: 'Aday (Ayşe)',
              text: 'I want to be cabin crew because I am passionate about customer service. At the hotel, the best moments were when guests said "thank you" with a big smile.',
              translation: 'Kabin memuru olmak istiyorum çünkü müşteri hizmetine tutkulum. Otelde en güzel anlar, misafirlerin kocaman bir gülümsemeyle "teşekkür ederim" dediği anlardı.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I also love the idea of working in a team. Every flight is different - new passengers, new colleagues, new destinations. That excites me!',
              translation: 'Ayrıca takım olarak çalışma fikrini seviyorum. Her uçuş farklı - yeni yolcular, yeni meslektaşlar, yeni destinasyonlar. Bu beni heyecanlandırıyor!'
            },
            {
              speaker: 'Aday (devam)',
              text: 'And I speak Turkish, English, and German. I want to use my language skills to help passengers from around the world.',
              translation: 'Ve Türkçe, İngilizce ve Almanca biliyorum. Dil becerilerimi dünyanın her yerinden yolculara yardım etmek için kullanmak istiyorum.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Cevap Analizi',
          content: '✅ **Güçlü noktalar:**\n• "Passionate about customer service" - hizmet odaklı\n• Otelden somut örnek verdi\n• Takım çalışması vurgusu\n• Dil becerileri - somut katkı\n\n❌ **Ne söylemedi:**\n• "Free travel" demedi\n• "Good salary" demedi\n• "Nice uniform" demedi'
        },
        {
          type: 'scenario',
          title: '✈️ Soru 3: Why Turkish Airlines?',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Why did you apply to Turkish Airlines specifically? Why not another airline?',
              translation: 'Özellikle neden Türk Hava Yolları\'na başvurdunuz? Neden başka bir havayolu değil?'
            },
            {
              speaker: 'Aday (Ayşe)',
              text: 'I have done a lot of research about THY. Turkish Airlines flies to more than 120 countries - that\'s more than any other airline in the world!',
              translation: 'THY hakkında çok araştırma yaptım. Türk Hava Yolları 120\'den fazla ülkeye uçuyor - bu dünyadaki herhangi bir havayolundan daha fazla!'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I\'m also very proud of Turkish hospitality. THY is famous for treating passengers like family, not just customers. This is exactly how I like to work.',
              translation: 'Ayrıca Türk misafirperverliğiyle gurur duyuyorum. THY, yolculara sadece müşteri değil, aile gibi davranmasıyla ünlü. Bu tam olarak çalışmak istediğim şekil.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'And Istanbul Airport is amazing - it connects East and West. I would be proud to be part of this global airline.',
              translation: 'Ve İstanbul Havalimanı muhteşem - Doğu ve Batı\'yı birleştiriyor. Bu global havayolunun parçası olmaktan gurur duyarım.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'I can see you\'ve done your homework! That\'s great.',
              translation: 'Araştırmanızı yaptığınızı görebiliyorum! Bu harika.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Cevap Analizi',
          content: '✅ **Neden mülakatçı etkilendi:**\n• Somut bilgi: 120+ ülke\n• Şirket değeri: Türk misafirperverliği\n• Hub bilgisi: İstanbul Havalimanı\n• "Research" yaptığını söyledi ve kanıtladı'
        },
        {
          type: 'tip',
          content: '💡 Her havayolunun web sitesini oku! Kaç ülkeye uçuyor, sloganı ne, değerleri ne - bunları bil.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '"Why cabin crew?" sorusunda hangisini söylememeli?',
          options: [
            'I am passionate about customer service',
            'I want to travel for free',
            'I love working in a team',
            'I want to use my language skills'
          ],
          correctIndex: 1,
          explanation: '"Free travel" = Tatil istiyorsun, iş değil. ASLA söyleme!'
        },
        {
          type: 'multipleChoice',
          question: 'THY kaç ülkeye uçuyor?',
          options: [
            '50+ ülke',
            '80+ ülke',
            '120+ ülke',
            '200+ ülke'
          ],
          correctIndex: 2,
          explanation: 'THY 129 ülkeye uçuyor - dünyada en çok ülkeye uçan havayolu!'
        }
      ]
    }
  },

  'B1INT-U3-L3': {
    id: 'B1INT-U3-L3',
    title: 'Tam Mülakat: Güçlü/Zayıf Yönler',
    type: 'simulation',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎭 En Zor Sorular',
          content: 'Ayşe şimdiye kadar harika! Ama şimdi en zor sorular geliyor:\n\n💪 Güçlü yönlerin neler?\n⚠️ Zayıf yönlerin neler?\n\nBu sorulara dürüst ama stratejik cevap vermek gerekir.'
        },
        {
          type: 'scenario',
          title: '✈️ Soru 4: What are your strengths?',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'What would you say are your main strengths?',
              translation: 'Temel güçlü yönleriniz neler dersiniz?'
            },
            {
              speaker: 'Aday (Ayşe)',
              text: 'My main strength is staying calm under pressure. At the hotel, we had very busy summer nights with hundreds of guests arriving at once.',
              translation: 'Temel güçlü yönüm baskı altında sakin kalmak. Otelde, aynı anda yüzlerce misafirin geldiği çok yoğun yaz geceleri yaşadık.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I learned to prioritize - help the urgent cases first, and always keep a smile. My manager called me "the calm one" in the team.',
              translation: 'Önceliklendirmeyi öğrendim - önce acil durumlarla ilgilen ve her zaman gülümsemeyi sürdür. Müdürüm bana takımda "sakin olan" derdi.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I\'m also very good at languages. I can help passengers in Turkish, English, and German.',
              translation: 'Ayrıca dillerde çok iyiyim. Yolculara Türkçe, İngilizce ve Almanca yardım edebilirim.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Cevap Analizi',
          content: '✅ **Neden iyi:**\n• Somut güçlü yön: "Staying calm under pressure"\n• Örnek: Yoğun yaz geceleri\n• Kanıt: Müdürün sözleri\n• İkinci güçlü yön: Dil becerileri (işe direkt katkı)'
        },
        {
          type: 'scenario',
          title: '✈️ Soru 5: What is your weakness?',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'And what about your weakness? What would you like to improve?',
              translation: 'Peki zayıf yönünüz? Neyi geliştirmek istersiniz?'
            },
            {
              speaker: 'Aday (Ayşe)',
              text: 'Honestly, I sometimes focus too much on small details. In the past, I would spend extra time making everything perfect.',
              translation: 'Dürüst olmak gerekirse, bazen küçük detaylara çok odaklanıyorum. Geçmişte her şeyi mükemmel yapmak için fazladan zaman harcardım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'But I\'m working on this. Now I ask myself: "Is this important for the guest?" If yes, I spend time. If no, I move on.',
              translation: 'Ama bunun üzerinde çalışıyorum. Şimdi kendime soruyorum: "Bu misafir için önemli mi?" Evet ise, zaman harcıyorum. Hayır ise, devam ediyorum.'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Zayıflık seç + Nasıl geliştirdiğini anlat = MÜKEMMEL CEVAP',
              translation: ''
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Cevap Analizi',
          content: '✅ **Neden akıllı bir cevap:**\n• Gerçek bir zayıflık seçti (detaylara takılma)\n• Aslında pozitif görülebilir (perfectionist)\n• Nasıl geliştirdiğini anlattı\n• "Working on it" = Öz-farkındalık var'
        },
        {
          type: 'warning',
          title: '⚠️ ASLA Söyleme',
          content: '❌ "I don\'t have any weakness" - İnanılmaz değil, samimiyetsiz\n❌ "I\'m often late" - Dakiklik kritik!\n❌ "I get angry with rude people" - Öfke = kabul edilemez\n❌ "I\'m lazy sometimes" - İşe yaramaz görünürsün'
        },
        {
          type: 'tip',
          content: '💡 İyi zayıflık formülü: Gerçek olsun + Çok ciddi olmasın + Üzerinde çalışıyor ol'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Hangisi mülakata uygun bir zayıflık?',
          options: [
            'I get angry with rude customers',
            'I am often late to work',
            'I sometimes focus too much on details, but I\'m working on it',
            'I don\'t have any weaknesses'
          ],
          correctIndex: 2,
          explanation: 'Detaylara takılmak aslında pozitif görülebilir. "But I\'m working on it" eklemek kritik!'
        }
      ]
    }
  },

  'B1INT-U3-L4': {
    id: 'B1INT-U3-L4',
    title: 'Tam Mülakat: Kapanış',
    type: 'simulation',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎭 Mülakat Sonu',
          content: 'Ayşe son soruları cevaplıyor. Mülakat kapanışı çok önemli - son izlenim de ilk izlenim kadar kritik!\n\n📌 Bu bölümde:\n• "5 yıl sonra" sorusu\n• Soru sorma fırsatı\n• Profesyonel kapanış'
        },
        {
          type: 'scenario',
          title: '✈️ Soru 6: Where do you see yourself in 5 years?',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Where do you see yourself in 5 years?',
              translation: '5 yıl sonra kendinizi nerede görüyorsunuz?'
            },
            {
              speaker: 'Aday (Ayşe)',
              text: 'In 5 years, I hope to be a senior cabin crew member at Turkish Airlines.',
              translation: '5 yıl içinde Türk Hava Yolları\'nda kıdemli kabin memuru olmayı umuyorum.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'First, I want to learn everything about the job. I want to fly to many destinations and gain experience with different types of passengers.',
              translation: 'Önce iş hakkında her şeyi öğrenmek istiyorum. Birçok destinasyona uçmak ve farklı yolcu tipleriyle deneyim kazanmak istiyorum.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Then, I would love to help train new crew members. Maybe one day, I can become a purser.',
              translation: 'Sonra yeni ekip üyelerini eğitmeye yardım etmek isterim. Belki bir gün kabin amiri olabilirim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'My goal is a long career with THY. I\'m not looking for a short-term job.',
              translation: 'Hedefim THY ile uzun bir kariyer. Kısa vadeli bir iş aramıyorum.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Cevap Analizi',
          content: '✅ **Ayşe şunları iyi yaptı:**\n• Şirket içinde büyüme hedefi (senior → purser)\n• Gerçekçi adımlar (öğren → deneyim kazan → eğit)\n• "Long career with THY" = Bağlılık gösteriyor\n• "Not short-term" = Güven veriyor'
        },
        {
          type: 'scenario',
          title: '✈️ Soru 7: Do you have any questions?',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'That\'s all from my side. Do you have any questions for us?',
              translation: 'Benden bu kadar. Bize sormak istediğiniz sorular var mı?'
            },
            {
              speaker: 'Aday (Ayşe)',
              text: 'Yes, I do! Could you tell me more about the training program? I\'m very interested in learning about safety procedures.',
              translation: 'Evet, var! Eğitim programı hakkında daha fazla bilgi verebilir misiniz? Güvenlik prosedürlerini öğrenmekle çok ilgileniyorum.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'Of course! The training is 8 weeks and covers safety, service, first aid, and emergency procedures.',
              translation: 'Tabii! Eğitim 8 hafta ve güvenlik, servis, ilk yardım ve acil durum prosedürlerini kapsıyor.'
            },
            {
              speaker: 'Aday (Ayşe)',
              text: 'That sounds wonderful. I also wanted to ask - what qualities does THY look for in a successful cabin crew?',
              translation: 'Harika görünüyor. Bir de sormak istedim - THY başarılı bir kabin memurunda hangi özellikleri arıyor?'
            },
            {
              speaker: 'Mülakatçı',
              text: 'Great question! We look for teamwork, adaptability, and a genuine care for passengers.',
              translation: 'Harika soru! Takım çalışması, uyum sağlama ve yolculara gerçek ilgi arıyoruz.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Soru Analizi',
          content: '✅ **İyi sorular:**\n• Eğitim programı hakkında (öğrenmeye istekli)\n• Başarılı kabin memuru özellikleri (gelişime açık)\n\n❌ **ASLA sorma:**\n• "Maaş ne kadar?"\n• "Kaç gün tatil var?"\n• "Nerede yaşayacağım?"\n• "İstediğim rotaları seçebilir miyim?"'
        },
        {
          type: 'scenario',
          title: '✈️ Kapanış',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Thank you so much for coming today, Ayşe. We will contact you within a week.',
              translation: 'Bugün geldiğiniz için çok teşekkür ederiz, Ayşe. Bir hafta içinde sizinle iletişime geçeceğiz.'
            },
            {
              speaker: 'Aday (Ayşe)',
              text: 'Thank you so much for this opportunity. I really enjoyed our conversation and I\'m very excited about this position.',
              translation: 'Bu fırsat için çok teşekkür ederim. Konuşmamızdan gerçekten keyif aldım ve bu pozisyon için çok heyecanlıyım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I hope to hear from you soon. Have a wonderful day!',
              translation: 'Yakında sizden haber almayı umuyorum. Harika bir gün geçirin!'
            },
            {
              speaker: 'Ortam',
              text: 'Ayşe stands up, shakes hands, smiles, and walks out confidently.',
              translation: 'Ayşe ayağa kalkıyor, el sıkışıyor, gülümsüyor ve kendinden emin bir şekilde çıkıyor.'
            }
          ]
        },
        {
          type: 'summary',
          title: '📊 Mülakat Özeti',
          content: '**✅ Ayşe\'nin başarı anahtarları:**\n1. Gülümsedi ve göz teması kurdu\n2. Basit ama etkili İngilizce kullandı\n3. Her soruda somut örnekler verdi\n4. Şirket araştırması yaptığı belliydi\n5. Zayıflığını pozitife çevirdi\n6. Profesyonel sorular sordu\n7. Pozitif ve enerjik kapanış yaptı'
        },
        {
          type: 'tip',
          content: '💡 Mülakattan sonra: Teşekkür e-postası gönder! "Thank you for the interview. I am very excited about the opportunity..."'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Mülakat sonunda sorulamayacak soru:',
          options: [
            'What does the training program include?',
            'What qualities do you look for in cabin crew?',
            'How much is the salary?',
            'When can I expect to hear from you?'
          ],
          correctIndex: 2,
          explanation: 'Maaş sorusu profesyonel değil. Şirket seni seçerse zaten söyleyecek!'
        },
        {
          type: 'multipleChoice',
          question: '"5 yıl sonra" sorusunda en iyi cevap:',
          options: [
            'I want to be a pilot',
            'I want to grow as senior crew, maybe become purser',
            'I don\'t know',
            'I want to work for Emirates'
          ],
          correctIndex: 1,
          explanation: 'Şirket içinde büyüme hedefi = bağlılık ve motivasyon gösterir.'
        }
      ]
    }
  },

  'B1INT-U3-EXAM': {
    id: 'B1INT-U3-EXAM',
    title: 'B1 Interview Final Exam',
    type: 'final_exam',
    content: {
      timeLimit: 25,
      passingScore: 70,
      questions: [
        {
          type: 'multipleChoice',
          question: 'What structure should you use when answering "Tell me about yourself"?',
          options: [
            'Only education',
            'Past → Present → Future',
            'Only hobbies',
            'Family and friends'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Which is the WORST answer to "Why do you want to be cabin crew?"',
          options: [
            'I am passionate about customer service',
            'I love working in a team',
            'I want to travel for free',
            'I want to use my language skills'
          ],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'What is Turkish Airlines\' slogan?',
          options: [
            'Fly with us',
            'Widen Your World',
            'The best airline',
            'Flying together'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'When describing a strength, what should you do?',
          options: [
            'Just say "I am calm"',
            'Give a specific example with evidence',
            'Say "I am perfect"',
            'List many strengths quickly'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Which is a GOOD answer to "What is your weakness?"',
          options: [
            'I don\'t have any weakness',
            'I get angry easily',
            'I focus too much on details, but I\'m working on time management',
            'I\'m often late to work'
          ],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'What should you say when asked "Where do you see yourself in 5 years?"',
          options: [
            'I want to be a pilot',
            'I don\'t know',
            'I want to work for another airline',
            'I want to grow as senior crew within your airline'
          ],
          correctIndex: 3
        },
        {
          type: 'multipleChoice',
          question: 'What is the best question to ask at the end of an interview?',
          options: [
            'How much is the salary?',
            'How many days off do I get?',
            'What does the training program include?',
            'Can I choose my routes?'
          ],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'In the LAST method, what does "L" stand for?',
          options: [
            'Look',
            'Leave',
            'Listen',
            'Love'
          ],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'What should you research before answering "Why our airline?"',
          options: [
            'Only the company name',
            'Number of destinations, company values, and slogan',
            'The CEO\'s name only',
            'Competitor airlines'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What should you do to make a good first impression in an interview?',
          options: [
            'Sit quietly and wait',
            'Smile, make eye contact, and offer a firm handshake',
            'Start answering questions immediately',
            'Check your phone'
          ],
          correctIndex: 1
        }
      ]
    }
  }
};

export default B1INT_UNIT_3;
